import React, { Component } from 'react'

export default class Organization extends Component {

  render() {
    return (
        <div>
          <div className="insid-header activity-header" style={{marginTop: '100px'}}>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="insid-header-text activity-header-text">
                    <h1 className="wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                      Organizzazione e processi aziendali
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section className="activity about2">
            <div className="container">
              <div className="row">
                <div className="col-sm-12 col-lg-12">
                  <div className="activity-text wow fadeIn animated" data-wow-duration=".5s" data-wow-delay=".2s">
                    <h2 className="activity-h2">Dettagli</h2>
                    <ul>
                      <li>Revisione dei modelli organizzativi in essere e sviluppo di nuove modalità organizzative.</li>
                      <li>Analisi dei ruoli e delle mansioni.</li>
                      <li>Revisione dei processi aziendali in logica lean per il miglioramento dell’efficienza.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/pages/organization.it.js